



















































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { Message } from 'element-ui'
import http from '../unite/http'
// @ts-ignore
import * as $ from 'jquery'
@Component({
  components: {}
})
export default class DialogUpload extends Vue {
  @Prop() optionTitle: any
  @Prop() rules: any
  @Prop() img: any
  @Prop() formList: any
  loading: boolean = false
  dialogVisible: boolean = true
  data: any = {}
  num: number = 0
  numWidth: string = '50%'
  // 确认
  confirm(formName: any) {
    ;(this.$refs[formName] as any).validate((valid: boolean) => {
      if (valid) {
        if (!$('#avatar').val()) {
          Message({
            message: '请选择文件',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        // @ts-ignore
        let formElement = document.forms['upload-form']
        let that = this
        let formdata = new FormData(formElement)
        Object.keys(this.formList.form).forEach(item => {
          formdata.append(item, this.formList.form[item])
        })
        this.loading = true
        $.ajax({
          url: '/upload',
          headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem('Apk-Jwt-Token')
          },
          type: 'post',
          data: formdata,
          contentType: false, //- 必须false才会自动加上正确的Content-Type
          processData: false, //- 必须false才会避开jQuery对 formdata 的默认处理,XMLHttpRequest会对 formdata 进行正确的处理
          success: function(d: any) {
            that.loading = false
            that.$emit('refesh', true)
            Message({
              message: '操作成功',
              type: 'success',
              duration: 5 * 1000
            })
          },
          error: function(error: any) {
            that.loading = false
            Message({
              message: error.responseText,
              type: 'warning',
              duration: 5 * 1000
            })
          }
        })
      }
    })
  }
  submit(file: any) {
    console.log(file)
  }
  aaa(file: any) {
    this.data = { ...this.formList.form }
    console.log(file)
  }
  // 取消
  cancel() {
    this.$emit('refesh', false)
  }
}
